import { FilterConfig, SortConfig } from 'store/types/Table';
import { MeetingView } from 'store/types/Meeting';
import { sorter } from 'util/table';

export enum MeetingTableActionType {
  SetInitialList = 'SetInitialList',
  UpdateSort = 'UpdateSort',
  UpdateFilter = 'UpdateFilter',
}

export interface MeetingTableState {
  initialList: MeetingView[];
  list: MeetingView[];
  sort: SortConfig<MeetingView>;
  filter: FilterConfig<MeetingView>;
}

export interface MeetingTableAction {
  type: MeetingTableActionType;
  payload: Partial<MeetingTableState>;
}

const getSortedList = (list: MeetingView[] = [], sort: SortConfig<MeetingView>): MeetingView[] =>
  list.length ? [...list].sort(sorter<MeetingView>(sort)) : [...list];

const getFilteredList = (list: MeetingView[] = [], filter: FilterConfig<MeetingView>) => {
  let result = [...list];
  const searchValue = (filter.search || '').toLowerCase();

  if (searchValue) {
    result = result.filter(({ title, committees }) => {
      const titleMatch = title.toLowerCase().includes(searchValue);
      const committeeMatch = committees?.some((c) => c.toLowerCase().includes(searchValue));
      return titleMatch || committeeMatch;
    });
  }

  return result;
};

export const initialState: MeetingTableState = {
  initialList: [],
  list: [],
  sort: { column: 'startDate', direction: 'asc' },
  filter: { search: '' },
};

const reducer = (state: MeetingTableState, { type, payload }: MeetingTableAction): MeetingTableState => {
  if (type === MeetingTableActionType.SetInitialList) {
    const { initialList = [] } = payload;
    const list = getSortedList(initialList ?? [], state.sort);

    return { ...state, initialList, list };
  }

  if (type === MeetingTableActionType.UpdateSort) {
    const { sort = {} } = payload;

    return {
      ...state,
      sort,
      list: getSortedList(state.initialList, sort),
    };
  }

  if (type === MeetingTableActionType.UpdateFilter) {
    const { filter = {} } = payload;
    const newFilter = { ...state.filter, ...filter };

    return {
      ...state,
      filter: newFilter,
      list: getFilteredList(getSortedList(state.initialList, state.sort), newFilter),
    };
  }

  return state;
};

export default reducer;
